// @ts-ignore
import Quill from '@cimpress-technology/quill/core';

export const { StyleAttributor, Scope } = Quill.import('parchment');

class CasingAttributor extends StyleAttributor {
    // eslint-disable-next-line class-methods-use-this
    private converter(value: string): string {
        // Converts CDIF 'default' to 'none' for CSS text-transform
        if (value === 'default') {
            return 'none';
        }

        return value;
    }

    public add(node: HTMLElement, value: any) {
        if (!super.canAdd(node, value)) {
            return false;
        }
        // eslint-disable-next-line no-param-reassign
        node.dataset.casing = value;

        return super.add(node, this.converter(value));
    }

    // eslint-disable-next-line class-methods-use-this
    public value(node: HTMLElement): any {
        if (!node.dataset.casing) {
            return '';
        }

        return node.dataset.casing;
    }
}

// @ts-ignore
export default new CasingAttributor('casing', 'text-transform', {
    scope: Scope.INLINE,
});
// @ts-ignore
export const BlockCasingAttributor = new CasingAttributor('blockCasing', 'text-transform', { scope: Scope.BLOCK });
